import { __awaiter, __generator } from "tslib";
import { createDeprecatedTextAreaAutosizeDriver } from '../../primitives/drivers';
export var createDeprecatedFormTextAreaDriver = function (wrapper) {
    var base = wrapper.$(".deprecated-form-text-area");
    var textAreaDriver = createDeprecatedTextAreaAutosizeDriver(base);
    return {
        getValue: function () { return __awaiter(void 0, void 0, void 0, function () { var txt; return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, textAreaDriver.getValue()];
                case 1:
                    txt = _a.sent();
                    return [2 /*return*/, txt];
            }
        }); }); },
        enterValue: function (value) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, textAreaDriver.enterValue(value)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); }); },
        checkIfDisabled: function () { return __awaiter(void 0, void 0, void 0, function () { var dis; return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, textAreaDriver.disabled()];
                case 1:
                    dis = _a.sent();
                    return [2 /*return*/, dis];
            }
        }); }); },
        checkIfErrorPresented: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.hasClass('.invalid')];
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map